/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */
import * as References from './ConnectedStatusGraphQLService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetch
 */
export const FETCH_QUERY_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetch';
export const FETCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetchAllForUser
 */
export const FETCH_ALL_FOR_USER_QUERY_FIELD_NAME = 'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetchAllForUser';
export const FETCH_ALL_FOR_USER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_ALL_FOR_USER_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.fetchAllForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});